// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var TextField = require("@mui/material/TextField").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_export_state_to_json(props) {
  var onClose = props.onClose;
  var match = Local_storage_utils.useStateFromLocalStorageBool("export-to-json-append-timestamp", false, props.tempMode);
  var setAppendTimestamp = match[1];
  var appendTimestamp = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setNotes = match$1[1];
  var notes = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setCopiedToClipboard = match$2[1];
  var actNotesChanged = function (newNotes) {
    Curry._1(setNotes, (function (param) {
            return newNotes;
          }));
  };
  var timestampStr = appendTimestamp ? Common.currTimeStr(undefined) + " " : "";
  var notesStr = notes.length > 0 ? notes + " " : "";
  var textToShow = timestampStr + notesStr + props.jsonStr;
  var actCopyToClipboard = function (param) {
    MM_react_common.copyToClipboard(textToShow);
    Curry._1(setCopiedToClipboard, (function (timerId) {
            if (timerId !== undefined) {
              Common.$$clearTimeout(Caml_option.valFromOption(timerId));
            }
            return Caml_option.some(Common.$$setTimeout((function (param) {
                              Curry._1(setCopiedToClipboard, (function (param) {
                                      
                                    }));
                            }), 1000));
          }));
  };
  var actCopyAndClose = function (param) {
    actCopyToClipboard(undefined);
    Curry._1(onClose, undefined);
  };
  var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyCodeEsc, undefined, undefined, undefined, onClose, undefined);
  var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyCodeEnter, undefined, undefined, undefined, actCopyAndClose, undefined);
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: appendTimestamp,
                                      onChange: (function (param) {
                                          return Expln_React_common.evt2bool((function (b) {
                                                        Curry._1(setAppendTimestamp, (function (param) {
                                                                return b;
                                                              }));
                                                      }), param);
                                        })
                                    }),
                                label: "append timestamp"
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    actCopyToClipboard(undefined);
                                  }),
                                variant: "contained",
                                style: {
                                  width: "90px"
                                },
                                children: Caml_option.some(Belt_Option.isSome(match$2[0]) ? "Copied" : "Copy")
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onClose, undefined);
                                  }),
                                children: "Close"
                              })), React.createElement(TextField, {
                            value: notes,
                            label: "Notes",
                            size: "small",
                            style: {
                              width: "350px"
                            },
                            onChange: (function (param) {
                                return Expln_React_common.evt2str(actNotesChanged, param);
                              }),
                            onKeyDown: (function (param) {
                                return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                              }),
                            autoFocus: true,
                            title: "Press Enter to copy to the clipboard and close this dialog window."
                          }), React.createElement("pre", {
                            style: {
                              overflow: "auto"
                            }
                          }, textToShow)))
            });
}

var make = MM_cmp_export_state_to_json;

exports.make = make;
/* react Not a pure module */
